import React from 'react';
import ArticleCard from '../components/ArticleCard';
import SectionHeader from '../components/SectionHeader';
import { Article, SectionData } from '../types/types';
import ImageCard from '../components/ImageCard';

interface CategoryTypeAProps {
  articlesData: Article[];
  sectionDatas: SectionData;
}

const CategoryTypeA: React.FC<CategoryTypeAProps> = ({ articlesData, sectionDatas }) => {
  const featuredArticle = articlesData[0];
  const otherArticles = articlesData.slice(1);
  const isExternal = sectionDatas.linkIcon === 'external';

  return (
    <div className="react-block__type-a">
      {sectionDatas && (
        <SectionHeader
          title={sectionDatas.title}
          linkLabel={sectionDatas.sectionLinkText}
          url={sectionDatas.sectionUrl}
          hasPreIcon={sectionDatas.showIcon}
          isExternal={isExternal}
          iconUrl={sectionDatas.iconUrl}
          hasTitleLink={sectionDatas.hasTitleLink}
          hideHeader={sectionDatas.hideHeader}
        />
      )}
      {featuredArticle && <ArticleCard article={featuredArticle} cardType={5} />}
      <div className="react-block__card-container react-block__card-container--type-a">
        {otherArticles.length > 0 &&
          otherArticles.map((article, index) =>
            article.type === 'image' ? (
              <ImageCard key={index} imageUrl={article.imageUrl || ''} link={article.link || '#'} />
            ) : (
              <ArticleCard key={article.id || index} article={article} cardType="one-third" />
            )
          )}
      </div>
    </div>
  );
};

export default CategoryTypeA;
